import { RouteConfig } from 'vue-router'
import i18n from '@/i18n'

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'connect',
        meta: { title: i18n.t('integration', { brand: process.env.VUE_APP_BRAND }) },
        component: () => import('@/modules/connect/views/Home.vue')
    }
]

export default routes
